import React from 'react';

interface ElementorButtonProps {
    onClick?: () => void;
    href?: string;
    className?: string;
}

const ElementorButton: React.FC<ElementorButtonProps> = (props) => {
    const { href, onClick, className = '' } = props;

    return (
        <div className="elementor-button-wrapper">
            <a
                className={['elementor-button-link elementor-button elementor-size-sm', className].join(' ')}
                {...(!!onClick ? { onClick } : {})}
                {...(!!href ? { href } : {})}>
                <span className="elementor-button-content-wrapper">
                    <span className="elementor-button-text">{props.children}</span>
                </span>
            </a>
        </div>
    );
};

export default ElementorButton;
